import {createAction} from "@reduxjs/toolkit";

export const setUISiteFilter = createAction<{
  id: string,
  fromDttm: number,
  toDttm?: number
}>("ots-ui/site/setFilter");
